// extracted by mini-css-extract-plugin
export default {"wrapper":"Birthdays_wrapper__pm76q","employees_list":"Birthdays_employees_list__5QzYT","employee":"Birthdays_employee__Ac731"};